export default "__VITE_ASSET__CmLsAYUb__"